import logo from "../../../assets/images/shelflogo.png";
import { Grid, Table, TableBody, TableCell, TableHead, TableRow, Paper, Box } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { pdfTheme } from "./PdfStyles";
import profile from "../../../assets/images/profile.png";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper
  },
  reportheader: {
    // backgroundColor: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.7).toRgbString(),
    backgroundColor: theme.palette.primary.main,
    padding: "36px",
    color: "#FFFFFF",
    textAlign: "center",
    "& h1": {
      fontWeight: 700,
      fontSize: "20px",
      marginBlock: "0px"
    },
    "& p": {
      fontWeight: 400,
      fontSize: "14px",
      color: "#FFFFFF",
      margin: "0px"
    }
  },
  imageWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
  },
  profiledata: {
    textAlign: "left",
    "& h6": {
      fontWeight: 400,
      fontSize: "12px",
      marginBlock: "0px",
      color: "#6D6D6D"
    },
    "& p": {
      fontWeight: 400,
      fontSize: "14px",
      marginBlock: "0px",
      color: "#344054"
    }
  },
  profile: {
    height: "80px",
    border: "1px solid #FFFFFF",
    "@media (max-width: 600px)": {
      marginTop: "10px"
    }
  },
  termdata: {
    marginBlock: "20px",
    width: "100%",
    padding: "8px",
    backgroundColor: theme.palette.primary.main,
    "& h1": {
      fontWeight: 700,
      fontSize: "16px",
      marginBlock: "0px",
      textAlign: "center",
      color: "#FFFFFF"
    }
  },
  container: {
    position: "relative",
    backgroundColor: "#f9fafc",
    borderRadius: 12,
    padding: 10,
    height: "100%",
    border: "1px solid #e0e0e0"
  },
  templatetitle: {
    fontWeight: 600,
    marginBottom: "1.5rem",
    fontSize: "1.25rem",
    color: "#111"
  },
  card: {
    borderRadius: 12,
    overflow: "hidden",
    border: "1px solid transparent",
    transition: "all 0.3s ease",
    cursor: "pointer",
    "&:hover": {
      borderColor: "#1976d2"
    }
  },
  activeCard: {
    borderColor: "#1976d2",
    boxShadow: "0 0 0 2px rgba(25, 118, 210, 0.3)"
  },
  mycards: {
    padding: "10px",
    marginRight: "10px",
    borderRadius: "8px"
  },
  lockedCard: {
    filter: "blur(2px)",
    cursor: "not-allowed"
  },
  image: {
    width: "100%",
    height: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem",
    "& svg": {
      width: "100%",
      height: "auto",
      maxHeight: 260,
      objectFit: "contain"
    }
  },
  templateName: {
    textAlign: "center",
    padding: "0.45rem 0",
    fontWeight: 500,
    fontSize: "0.95rem",
    color: "#333",
    margin: 0
  },
  locknote: {
    width: "97%",
    position: "absolute",
    bottom: "10px",
    right: "10px",
    left: "10px",
    display: "flex",
    alignItems: "flex-start",
    gap: "6px",
    justifyContent: "flex-start",
    textAlign: "left",
    marginTop: "1.5rem",
    background: "#fff",
    padding: "0.75rem 1rem",
    borderRadius: 8,
    border: "1px dashed #ccc",
    fontSize: "0.85rem",
    color: "#555",
    "& p": {
      marginBlock: "0px"
    }
  },
  titlediv: {
    width: "100%",
    height: "46px",
    boxSizing: "border-box",
    paddingLeft: "10px",
    paddingRight: "10px",
    border: "1px solid hsl(0, 0%, 80%)",
    marginTop: "4px",
    borderRadius: "6px",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#667185",
    "& input": {
      border: "none",
      outline: "none",
      fontSize: "14px",
      color: "#667185",
      background: "transparent",
      width: "100%"
    } },
  secondreportmain: {
    position: "relative"
  },
  secondreportheader: {
    // backgroundColor: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.7).toRgbString(),
    // backgroundColor: "#E0E0E0",
    padding: "36px",
    color: theme.palette.primary.main,
    textAlign: "center",
    "& h1": {
      fontWeight: 700,
      fontSize: "20px",
      marginBlock: "0px"
    },
    "& p": {
      fontWeight: 400,
      fontSize: "14px",
      margin: "0px"
    }
  },
  secondlogoContent: {
    height: "50px"
  },
  stdninfo: {
    paddingInline: "16px"
  },
  topBorderWrapper: {
    position: "relative",
    width: "100%",
    height: "40px",
    backgroundColor: "#fff",
    overflow: "hidden"
  },
  topBorder: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "40px",
    width: "100%",
    backgroundColor: theme.palette.primary.main,
    clipPath: "polygon(0 0, 94% 0, 93% 40%, 0 40%)"
  },
  topBorderInner: {
    position: "absolute",
    top: 10,
    right: 0,
    height: "10px",
    width: "100%",
    backgroundColor: "#fff",
    clipPath: "polygon(6% 0, 100% 0, 100% 100%, 7% 100%)"
  },
  secondtermdata: {
    marginBlock: "20px",
    width: "100%",
    padding: "16px 8px 8px 8px",
    // backgroundColor: theme.palette.primary.main,
    "& h1": {
      fontWeight: 700,
      fontSize: "16px",
      marginBlock: "0px",
      textAlign: "center",
      color: theme.palette.primary.main
    }
  },
  tembottomimage: {
    width: "100%",
    fill: theme.palette.primary.main
  },
  borderleftright: {
    borderLeft: `2px solid ${theme.palette.primary.main} `,
    borderRight: `2px solid ${theme.palette.primary.main} `
  },
  linescontainer: {
    display: "flex",
    flexDirection: "column",

    gap: "6px",
    width: "100%",
    // maxWidth: "400px",
    alignItems: "center"
  },
  line1: {
    height: "2.97px",
    width: "60%",
    backgroundColor: theme.palette.primary.main
  },
  line2: {
    height: "2.97px",
    width: "65%",
    backgroundColor: theme.palette.primary.main
  },
  line3: {
    height: "2.97px",
    width: "60%",
    backgroundColor: theme.palette.primary.main
  }
}), { defaultTheme: pdfTheme });

const PublishTemplateContent = ({ reportData, extraData }) => {
  const classes = useStyles();
  // const attendanceData = {
  //   total: reportData?.attendance?.total_days || 10,
  //   present: reportData?.attendance?.present_days || 8,
  //   absent: reportData?.attendance?.absent_days || 2
  // };

  return (
    <div className="page-content container-border">
      <div className={classes.reportmain}>
        <div className={classes.reportheader}>
          <Grid container spacing={2}>
            <Grid lg={3} md={3} sm={3} xs={12}>
              <div className={classes.imageWrapper}>
                <img
                  src={ logo}
                  alt="App Logo"
                  className={classes.logoContent}
                />
              </div>
            </Grid>
            <Grid lg={6} md={6} sm={6} xs={12}>
              <div className={classes.reportheadertext}>
                <h1>{reportData?.school_name || "--/--"}</h1>
                <p>{reportData?.school_address || "--/--"}</p>
                <p>{reportData?.phone_number || "--/--"}, {reportData?.email || "--/--"}</p>
              </div>
            </Grid>
            <Grid lg={3} md={3} sm={3} xs={12}>
              <div>
                <img
                  src={reportData?.display_pic?.file_url || profile}
                  alt="Profile"
                  className={classes.profile}
                />
              </div>
            </Grid>
          </Grid>
        </div>
        <div className={classes.termdata}>
          <h1>2024/2025 FIRST TERM STUDENT REPORT</h1>
        </div>
        <Grid container spacing={2}>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>STUDENT NAME</h6>
              <p>{reportData?.last_name || "--/--"} {reportData?.first_name || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>SEX</h6>
              <p>{reportData?.gender || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>CLASS</h6>
              <p>{reportData?.class?.name || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>SESSION</h6>
              <p>{reportData?.session?.session || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>STUDENT TYPE</h6>
              <p>{"--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>ADMISSION DATE.</h6>
              <p>{reportData?.admission_date?.substring(0, 10) || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>CLASS POPULATION</h6>
              <p>{reportData?.class_population || "--/--"}</p>
            </div>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <div className={classes.profiledata}>
              <h6>DATE ENROLLED</h6>
              <p>{reportData?.date_enrolled || "--/--"}</p>
            </div>
          </Grid>
        </Grid>
        <div className={classes.termdata}>
          <h1>SUBJECTS</h1>
        </div>
      </div>
      {/* Subject Results */}
      <div style={{ marginTop: "16px", width: "100%" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            border: "1px solid #e0e0e0",
            marginTop: "16px"
          }}
        >
          <thead style={{ backgroundColor: "#f9fafb" }}>
            <tr>
              <th style={{
                padding: "8px 12px",
                border: "1px solid #e0e0e0",
                textAlign: "left",
                fontWeight: "500",
                width: "200px"
              }}
              >Subject
              </th>
              <th style={{
                padding: "8px 12px",
                border: "1px solid #e0e0e0",
                textAlign: "center"
              }}
              >CA 1<br /><small>(20)</small>
              </th>
              <th style={{
                padding: "8px 12px",
                border: "1px solid #e0e0e0",
                textAlign: "center"
              }}
              >CA 2<br /><small>(20)</small>
              </th>
              <th style={{
                padding: "8px 12px",
                border: "1px solid #e0e0e0",
                textAlign: "center"
              }}
              >Exam<br /><small>(60)</small>
              </th>
              <th style={{
                padding: "8px 12px",
                border: "1px solid #e0e0e0",
                textAlign: "center"
              }}
              >Total<br /><small>(100)</small>
              </th>
              <th style={{
                padding: "8px 12px",
                border: "1px solid #e0e0e0",
                textAlign: "center"
              }}
              >Term 1<br /><small>(100)</small>
              </th>
              <th style={{
                padding: "8px 12px",
                border: "1px solid #e0e0e0",
                textAlign: "center"
              }}
              >Class<br />Highest
              </th>
              <th style={{
                padding: "8px 12px",
                border: "1px solid #e0e0e0",
                textAlign: "center"
              }}
              >Class<br />Lowest
              </th>
              <th style={{
                padding: "8px 12px",
                border: "1px solid #e0e0e0",
                textAlign: "center"
              }}
              >Class<br />Average
              </th>
              <th style={{
                padding: "8px 12px",
                border: "1px solid #e0e0e0",
                textAlign: "center"
              }}
              >Grade
              </th>
            </tr>
          </thead>
          <tbody>
            {reportData?.subjects?.map((row, idx) => (
              <tr key={idx}>
                <td style={{
                  padding: "8px 12px",
                  border: "1px solid #e0e0e0",
                  backgroundColor: "#fff",
                  width: "200px"
                }}
                >{row.name}
                </td>
                <td style={{
                  padding: "8px 12px",
                  border: "1px solid #e0e0e0",
                  textAlign: "center"
                }}
                >{row?.scores?.CA_scores?.CA1}
                </td>
                <td style={{
                  padding: "8px 12px",
                  border: "1px solid #e0e0e0",
                  textAlign: "center"
                }}
                >{row?.scores?.CA_scores?.CA2}
                </td>
                <td style={{
                  padding: "8px 12px",
                  border: "1px solid #e0e0e0",
                  textAlign: "center"
                }}
                >{row?.scores?.exam_score}
                </td>
                <td style={{
                  padding: "8px 12px",
                  border: "1px solid #e0e0e0",
                  textAlign: "center"
                }}
                >{row?.scores?.total}
                </td>
                <td style={{
                  padding: "8px 12px",
                  border: "1px solid #e0e0e0",
                  textAlign: "center"
                }}
                >{row?.term1}
                </td>
                <td style={{
                  padding: "8px 12px",
                  border: "1px solid #e0e0e0",
                  textAlign: "center"
                }}
                >{row?.scores?.class_highest_score}
                </td>
                <td style={{
                  padding: "8px 12px",
                  border: "1px solid #e0e0e0",
                  textAlign: "center"
                }}
                >{row?.scores?.class_lowest_score}
                </td>
                <td style={{
                  padding: "8px 12px",
                  border: "1px solid #e0e0e0",
                  textAlign: "center"
                }}
                >{row?.scores?.class_average_score}
                </td>
                <td style={{
                  padding: "8px 12px",
                  border: "1px solid #e0e0e0",
                  textAlign: "center"
                }}
                >{row?.scores?.grade}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {(reportData?.extras?.length) && (
        <Grid container spacing={3} sx={{ mt: 1 }}>
          {reportData?.extras?.length > 0 ? (
            <>
              {reportData.extras
                .filter(item => item.section_type === "grade" || item.section_type === "score")
                .map((section, index) => (
                  <Grid item xs={12} md={6} key={index}>
                    <Paper elevation={2} sx={{ borderRadius: 2, p: "8px 14px" }}>
                      <Box sx={{ position: "relative" }}>
                        <div className={classes.termdata}>
                          <h1>{section.section_name.toUpperCase()}</h1>
                        </div>
                        {/* <Box sx={{
                                        bgcolor: "white",
                                        padding: "0.5rem",
                                        borderRadius: "6px",
                                        position: "absolute",
                                        top: -28,
                                        right: -10
                                      }}
                                      >
                                        <IconButton
                                          sx={{ bgcolor: "white", boxShadow: 2 }}
                                          size="small"
                                        >
                                          <EditIcon fontSize="small" />
                                        </IconButton>
                                        <IconButton
                                          sx={{ bgcolor: "white", boxShadow: 2, ml: 1 }}
                                          size="small"
                                        >
                                          <DeleteIcon fontSize="small" color="error" />
                                        </IconButton>
                                      </Box> */}
                      </Box>

                      <Table sx={{ mt: 2 }}>
                        <TableHead sx={{ backgroundColor: "#f9fafb" }}>
                          <TableRow>
                            <TableCell>ACTIVITY</TableCell>
                            <TableCell align="right">
                              {section.section_type === "grade" ? "GRADE" : "SCORE"}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {Object.entries(section.section_value).map(([activity, value]) => (
                            <TableRow key={`${section.section_name}-${activity}`}>
                              <TableCell>
                                {activity.split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1)
                                ).join(" ")}
                              </TableCell>
                              <TableCell align="right">
                                {value}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Paper>
                  </Grid>
                ))}
              {reportData.extras
                .filter(item => item.section_type === "text")
                .map((section, index) => (
                  <Grid item lg={6} md={6} sm={6} xs={12} key={index}>
                    <Paper elevation={2} sx={{ borderRadius: 2, p: "8px 14px" }}>
                      <Box sx={{ position: "relative" }}>
                        <div className={classes.termdata}>
                          <h1>TEACHER’S COMMENT</h1>
                        </div>
                      </Box>

                      <Box
                        sx={{
                          mt: 2,
                          p: 2,
                          borderRadius: 2,
                          backgroundColor: "#f9fafb",
                          fontSize: "0.95rem",
                          textAlign: "left",
                          color: "#333"
                        }}
                      >
                        {section?.section_value }
                      </Box>
                    </Paper>
                  </Grid>
                ))}

            </>
          ) : (
            extraData?.extras?.map((section, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Paper elevation={2} sx={{ borderRadius: 2, p: "8px 14px" }}>
                  <Box sx={{ position: "relative" }}>
                    <div className={classes.termdata}>
                      <h1>{section.section_name.toUpperCase()}</h1>
                    </div>
                    <Box sx={{
                      bgcolor: "white",
                      padding: "0.5rem",
                      borderRadius: "6px",
                      position: "absolute",
                      top: -28,
                      right: -10
                    }}
                    >
                      <IconButton
                        sx={{ bgcolor: "white", boxShadow: 2 }}
                        size="small"
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        sx={{ bgcolor: "white", boxShadow: 2, ml: 1 }}
                        size="small"
                      >
                        <DeleteIcon fontSize="small" color="error" />
                      </IconButton>
                    </Box>
                  </Box>

                  <Table sx={{ mt: 2 }}>
                    <TableHead sx={{ backgroundColor: "#f9fafb" }}>
                      <TableRow>
                        <TableCell>ACTIVITY</TableCell>
                        <TableCell align="right">
                          {section.section_type === "grade" ? "GRADE" : "SCORE"}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {section.section_titles?.map((activity) => (
                        <TableRow key={`${section.section_name}-${activity}`}>
                          <TableCell>
                            {activity.split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1)
                            ).join(" ")}
                          </TableCell>
                          <TableCell align="right">
                            {/* Placeholder - you might want to fetch actual values */}
                            {section.section_type}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Paper>
              </Grid>

            )))}
        </Grid>
      )}
    </div>
  );
};

const PublishTemplate = (props) => (
  <ThemeProvider theme={pdfTheme}>
    <PublishTemplateContent {...props} />
  </ThemeProvider>
);

export const PublishTemplateForPDF = (props) => (
  <ThemeProvider theme={pdfTheme}>
    <PublishTemplateContent {...props} isPDF={true} />
  </ThemeProvider>
);

export default PublishTemplate;
